import { OverflowMenu } from 'ui/actionMenu';
import { BUTTON_SIZES } from 'ui/button';

import { useSecondaryActionMenuOptions } from './hooks';

export const SecondaryActionsMenu = () => {
  const options = useSecondaryActionMenuOptions();
  return <OverflowMenu options={options} size={BUTTON_SIZES.LARGE} />;
};
